import React, {useState} from "react"
import {Paper, Stack, Box, useTheme} from "@mui/material"
import {useNavigate, useOutletContext} from "react-router-dom"
import ButtonWithIcon from "src/v2/components/Button/Button"
import {ReactComponent as TrashIcon} from "src/v2/assets/icons/trash-icon.svg"
import {ReactComponent as CopyIcon} from "src/v2/assets/icons/copy-icon.svg"
import {ReactComponent as PasteIcon} from "src/v2/assets/icons/paste-icon.svg"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import {eventosOrdinariosFields} from "./eventos-ordinarios-fields"
import {DynamicColumnTable} from "../componentes/dynamic-column-table"
import FormActions from "../../components/FormActions"
import {dispatchSnackbar} from "../../../../components/SnackBar/snackbar-bus"

const TABLE_DATA_DEFAULT = [{}]
const MIN_COLS_ITEMS_TABLE = 7
const CSV_SEPARATOR = ";"

export const EventosOrdinariosPage = () => {
    const theme = useTheme()
    const navigate = useNavigate()

    const [tableData, setTableData] = useState(TABLE_DATA_DEFAULT)

    const handleCellChange = ({rowIndex, colIndex, value}) => {
        const isEmptyValue = (v) => v == null || String(v).trim() === ""

        const isColumnEmpty = (column) => {
            if (!column) return true

            return eventosOrdinariosFields.every((field) =>
                isEmptyValue(column[field.key])
            )
        }

        const createEmptyColumn = () => {
            const emptyColumn = {}
            eventosOrdinariosFields.forEach((field) => {
                emptyColumn[field.key] = ""
            })
            return emptyColumn
        }

        const newData = [...tableData]

        while (newData.length < MIN_COLS_ITEMS_TABLE) {
            newData.push(createEmptyColumn())
        }

        if (!newData[colIndex]) {
            newData[colIndex] = createEmptyColumn()
        }

        if (rowIndex === -1) {
            newData[colIndex] = {
                ...newData[colIndex],
                [eventosOrdinariosFields[0].key]: value,
            }
        } else {
            const fieldKey = eventosOrdinariosFields[rowIndex + 1]?.key

            newData[colIndex] = {
                ...newData[colIndex],
                [fieldKey]: value,
            }
        }

        if (!isColumnEmpty(newData[newData.length - 1])) {
            newData.push(createEmptyColumn())
        }

        while (
            newData.length > MIN_COLS_ITEMS_TABLE &&
            isColumnEmpty(newData[newData.length - 1]) &&
            isColumnEmpty(newData[newData.length - 2])
            ) {
            newData.pop()
        }

        setTableData(newData)
    }

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const {caracteristicaState} = useOutletContext() || {}
    // se tiver ID, é produção (true). Se não tiver, é temporário (false).
    const isPublished = Boolean(caracteristicaState?.ID)

    const handleSave = () => {
        console.log("Salvando dados...")
        // Aqui entraria a chamada da api
    }

    const handlePublish = () => {
        console.log("Publicando evento...")
    }

    const handleDelete = () => {
        console.log("Deletando registro...")
        setDeleteConfirmOpen(false)
        navigate(-1) // volta para a tela anterior após deletar
    }

    const clearTable = () => {
        setTableData(TABLE_DATA_DEFAULT)
    }

    const escapeCsvValue = (value) => {
        if (value == null) return ""
        const stringValue = String(value)

        if (
            stringValue.includes(CSV_SEPARATOR) ||
            stringValue.includes('"') ||
            stringValue.includes("\n")
        ) {
            return `"${stringValue.replace(/"/g, '""')}"`
        }

        return stringValue
    }

    const copyTable = async () => {
        if (!tableData.length) return

        const headers = eventosOrdinariosFields.map((field) => field.key)
        const csv = [
            headers.join(CSV_SEPARATOR),
            ...tableData.map((row) =>
                headers.map((header) => escapeCsvValue(row[header])).join(CSV_SEPARATOR)
            ),
        ].join("\n")

        try {
            console.log(tableData)
            await navigator.clipboard.writeText(csv)
            dispatchSnackbar("Dados copiados para a área de transferência", "success")
        } catch (error) {
            dispatchSnackbar(`Erro ao copiar a tabela: ${error}`, "error")
        }
    }

    const handlePasteFromClipboard = async () => {
        try {
            const text = await navigator.clipboard.readText()
            if (!text?.trim()) return

            const rows = text
                .trim()
                .split(/\r?\n/)
                .filter(r => r.trim() !== "")
                .slice(1)

            const keys = eventosOrdinariosFields.map((field) => field.key)
            const data = rows.map(row => {
                const cols = row.split("\t")
                const obj = {}

                cols.forEach((value, index) => {
                    const key = keys[index]
                    if (key) {
                        obj[key] = value.trim()
                    }
                })

                return obj
            })
            setTableData(data)
        } catch (error) {
            console.error("Erro ao ler clipboard:", error)
        }
    }

    return (
        <Paper sx={{p: 2}}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <ButtonWithIcon icon={<TrashIcon/>} size="md" onClick={clearTable}>
                    LIMPAR
                </ButtonWithIcon>

                <Stack direction="row" spacing={2}>
                    <ButtonWithIcon icon={<CopyIcon/>} size="md" onClick={copyTable}>
                        COPIAR
                    </ButtonWithIcon>

                    <ButtonWithIcon icon={<PasteIcon/>} size="md" onClick={handlePasteFromClipboard}>
                        COLAR
                    </ButtonWithIcon>
                </Stack>
            </Stack>

            <Stack sx={{mt: 2}}>
                <DynamicColumnTable
                    fields={eventosOrdinariosFields}
                    items={tableData}
                    onCellChange={handleCellChange}
                />
            </Stack>

            <Box sx={{mx: {xxxs: -3, md: -3, lg: 0}, mt: 4}}>
                <FormActions
                    showBack
                    onBack={() => navigate(-1)}

                    onDelete={() => setDeleteConfirmOpen(true)}
                    deleteOpen={deleteConfirmOpen}
                    setDeleteOpen={setDeleteConfirmOpen}
                    onConfirmDelete={handleDelete}


                    showSave={!isPublished}
                    onSave={handleSave}

                    onPublish={handlePublish}
                    publishLabel={isPublished ? "SALVAR E PUBLICAR" : "PUBLICAR"}
                    publishIcon={<CheckIcon/>}

                    theme={theme}/>
            </Box>
        </Paper>
    )
}
